// routes
export const ROUTES = {
  HOME: "/",
  SERVICES: "/#leistungen",
  SOCIAL: "/#social-media",
  ABOUT: "/#ueber-uns",
  CONTACT: "/#kontakt",
};

// KI Werbestudio + Social Pro merged data
export const COMPANY = {
  name: "KI Werbestudio",
  tagline: "Kreativität trifft auf Technologie",
  subTagline: "Maßgeschneiderte KI-Lösungen & professionelles Social-Media-Management",
  founder: "Mario Dudacy",
  address: "Hammerstraße 9, 08451 Neukirchen/Pleiße",
  phone: "015143120308",
  email: "info@pixnetmedia.de",
  website: "www.pixnetmedia.de",
  experience: "30+",
  founded: "1994",
  openingHours: "Mo–Fr 07:00–18:00 Uhr",
};

export const STATS = [
  { value: "30+", label: "Jahre Erfahrung" },
  { value: "15+", label: "Social-Media-Vorteile" },
  { value: "100%", label: "Professionelle Betreuung" },
  { value: "360°", label: "Komplette Kommunikation" },
];

export interface Service {
  icon: string;
  title: string;
  description: string;
  features: string[];
  category: "ki" | "social";
}

export const SERVICES: Service[] = [
  {
    icon: "🎨",
    title: "Kreative KI-Designs",
    description: "Wir erstellen ansprechende und einprägsame Designs, die Ihrer Marke Identität verleihen – unterstützt durch modernste KI-Technologie.",
    features: ["Logo & Corporate Design", "Printmedien & Werbematerialien", "Digitale Grafiken & Banner", "Produktvisualisierungen"],
    category: "ki",
  },
  {
    icon: "🤖",
    title: "Innovative KI-Konzepte",
    description: "Unsere Konzepte basieren auf den neuesten Technologien der Künstlichen Intelligenz – für Ergebnisse, die überzeugen.",
    features: ["KI-gestützte Bildgenerierung", "Automatisierte Content-Erstellung", "Personalisierte Marketinglösungen", "Intelligente Kampagnenplanung"],
    category: "ki",
  },
  {
    icon: "⚙️",
    title: "Maßgeschneiderte Lösungen",
    description: "Individuelle Lösungen für Unternehmen und Privathaushalte – wir setzen Ihre Wünsche und Fantasien präzise um.",
    features: ["Individuelle Projektkonzeption", "Unternehmens- & Privatprojekte", "Europaweite Umsetzung", "Langfristige Partnerschaft"],
    category: "ki",
  },
  {
    icon: "📱",
    title: "Social-Media-Strategie",
    description: "Strategische Kommunikation statt spontaner Beiträge – wir planen Inhalte gezielt nach Unternehmenszielen und Zielgruppen.",
    features: ["Plattformstrategie (Meta, LinkedIn, TikTok)", "Redaktionsplanung & Kampagnen", "Zielgruppenanalyse", "Wettbewerbsbeobachtung"],
    category: "social",
  },
  {
    icon: "✍️",
    title: "Content-Erstellung",
    description: "Professionelle Texte, Bilder und Videos – optimal auf die jeweilige Plattform und Ihre Marke abgestimmt.",
    features: ["Copywriting & Texterstellung", "KI-gestützte Bildproduktion", "Video-Content & Reels", "Hashtag-Strategie & SEO"],
    category: "social",
  },
  {
    icon: "📊",
    title: "Community & Analytics",
    description: "Laufende Analyse, Community-Betreuung und Krisenmanagement – für nachhaltig starke Markenpräsenz.",
    features: ["Community Management", "Kommentar- & Anfragenbetreuung", "KPI-Analyse & Reporting", "Bezahlte Kampagnenoptimierung"],
    category: "social",
  },
];

export const SOCIAL_BENEFITS = [
  { icon: "🎯", title: "Einheitlicher Markenauftritt", desc: "Konsistente Botschaften auf allen Plattformen für ein professionelles Markenbild." },
  { icon: "📈", title: "Strategische Kommunikation", desc: "Gezielte Planung nach Unternehmenszielen für maximale Reichweite." },
  { icon: "⭐", title: "Professionelle Content-Erstellung", desc: "Hochwertige Texte, Bilder und Videos, plattformoptimiert." },
  { icon: "⏱️", title: "Zeitersparnis", desc: "Konzentrieren Sie sich auf Ihr Kerngeschäft – wir übernehmen die Kommunikation." },
  { icon: "💬", title: "Schnelle Reaktionszeiten", desc: "Zeitnahe Beantwortung von Kommentaren und Kundenanfragen." },
  { icon: "👥", title: "Bessere Zielgruppenansprache", desc: "Inhalte, die exakt auf Interessen, Bedürfnisse und Trends abgestimmt sind." },
  { icon: "🚀", title: "Höhere Reichweite", desc: "Fachwissen zu Algorithmen und Trends für mehr organische Sichtbarkeit." },
  { icon: "📅", title: "Kontinuierliche Betreuung", desc: "Strukturierte, regelmäßige Kommunikation ohne Lücken." },
  { icon: "🛡️", title: "Krisenmanagement", desc: "Souveräne und markenschonende Reaktion bei negativer Kritik." },
  { icon: "📉", title: "Messbare Ergebnisse", desc: "Laufende Analyse und Optimierung aller Maßnahmen anhand von KPIs." },
  { icon: "💡", title: "Aktuelles Fachwissen", desc: "Neue Entwicklungen, Funktionen und Trends werden gezielt eingesetzt." },
  { icon: "❤️", title: "Stärkere Kundenbindung", desc: "Regelmäßige Kommunikation stärkt die Community-Beziehung." },
  { icon: "💰", title: "Effizienter Werbeeinsatz", desc: "Zielgerichtete Kampagnen reduzieren Streuverluste." },
  { icon: "🏆", title: "Wettbewerbsvorteil", desc: "Professioneller wirken als Wettbewerber mit unstrukturiertem Auftritt." },
  { icon: "🌱", title: "Langfristiger Markenaufbau", desc: "Nachhaltiger Aufbau von Vertrauen, Reputation und Bekanntheit." },
];
